// In-code course database for the G-New Features sandbox handicap calculator.
//
// Deterministic, offline stand-in for GolfGamesScorecard's live course
// library (useCourses / golfCourseApi). Each course carries par, an 18-hole
// stroke index, and tee boxes with slope/rating — everything the handicap
// math needs. Real course search/import is a move-to-live concern; here the
// data is baked so the sandbox stays reproducible with zero external calls.

export const SAMPLE_COURSES = [
  {
    // Real Pine Bluff Country Club data (golfcourseapi id 18840) — par 71.
    id: 'pinebluff',
    name: 'Pine Bluff Country Club',
    par: 71,
    pars: [5, 3, 4, 4, 3, 4, 4, 5, 3, 4, 5, 4, 3, 5, 4, 3, 4, 4],
    strokeIndex: [7, 15, 3, 11, 13, 1, 9, 5, 17, 2, 12, 6, 10, 8, 18, 14, 16, 4],
    address: '1100 W 46th Ave',
    city: 'Pine Bluff',
    state: 'AR',
    tees: [
      { name: 'Blue', color: 'blue', slope: 134, rating: 71.7 },
      { name: 'White', color: 'white', slope: 130, rating: 70.4 },
      { name: 'Gold', color: 'gold', slope: 137, rating: 73.4 },
      { name: 'Red', color: 'red', slope: 116, rating: 65.5 },
    ],
  },
  {
    id: 'riverside',
    name: 'Riverside Links',
    par: 71,
    pars: [4, 4, 5, 3, 4, 4, 3, 5, 4, 4, 4, 3, 4, 5, 4, 3, 4, 4],
    strokeIndex: [5, 1, 11, 17, 3, 7, 15, 9, 13, 6, 2, 18, 8, 12, 4, 16, 10, 14],
    tees: [
      { name: 'Black', color: 'black', slope: 138, rating: 73.6 },
      { name: 'Blue', color: 'blue', slope: 131, rating: 71.0 },
      { name: 'White', color: 'white', slope: 125, rating: 68.9 },
    ],
  },
  {
    id: 'meadowcreek',
    name: 'Meadow Creek',
    par: 70,
    pars: [4, 3, 4, 5, 4, 4, 3, 4, 4, 4, 4, 3, 5, 4, 4, 3, 4, 4],
    strokeIndex: [9, 15, 1, 5, 11, 3, 17, 7, 13, 8, 2, 16, 6, 10, 4, 18, 12, 14],
    tees: [
      { name: 'Blue', color: 'blue', slope: 122, rating: 69.8 },
      { name: 'White', color: 'white', slope: 116, rating: 67.5 },
      { name: 'Red', color: 'red', slope: 110, rating: 65.2 },
    ],
  },
]

export function listCourses() {
  return SAMPLE_COURSES
}

export function getCourse(id) {
  return SAMPLE_COURSES.find((c) => c.id === id) || null
}

export function teesFor(id) {
  return getCourse(id)?.tees || []
}
